import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import * as common from 'libs/common';

import { IApprItemState, IApprRefUsrItemState, IAttachFileItemState, IComCdItemState, ICom0109MState } from '../../models/com/com0109m_model';
  
const initialState: ICom0109MState = {
    fileList        : [],   // 첨부파일 목록
    attachFileItems : [],   // 첨부파일 목록
    approvalList    : [],   // 결재자목록
    refList         : [],   // 참조자목록
    apprDcdList     : [],   // 결재구분코드목록
    apprOpns        : [],   // 결재의견목록
    apprOpn         : '',   // 결재의견
    isNotAuth       : true,
    apprItems       : {
        apprDcd : null,     // 결재구분코드
        apprEmpNo : '',     // 결재자사원번호
        apprNo : '',        // 결재번호
        apprStCd : '',      // 결재상태코드
        cdNm : '',          // 결재문서명
        cntnt : '',         // 결재문서내용
        mainApprStCd : '',  // 결재메인상태코드
        empNo : '',         // 결재요청자사번
        reqEmpNo : '',      // 결재요청자
        reqUserNm : '',     // 결재요청자이름
        title : '',         // 제목
    }
}

export const com0109m_Slice = createSlice({
    name: "com0109m_Slice",
    initialState: initialState,
    reducers: {
        initState: (state) => {
            Object.assign(state, {...initialState
                                   , apprDcdList: state.apprDcdList
                                   , apprItems : { ...initialState.apprItems
                                                    , empNo : common.getEmpNo()
                                                    , reqEmpNo : common.getEmpNo()
                                                    , reqUserNm : common.getUserNm() }
                                                 });
        },
        setIsNotAuth: (state, action:PayloadAction<boolean>) => {
            state.isNotAuth = action.payload;
        },
        setApprOpns: (state, action:PayloadAction<any[]>) => {
            state.apprOpns = action.payload;
        },
        setApprOpn: (state, action:PayloadAction<string>) => {
            state.apprOpn = action.payload;
        },
        setApprItems: (state, action:PayloadAction<IApprItemState>) => {
            state.apprItems = action.payload;
        },
        setApprovalList: (state, action:PayloadAction<IApprRefUsrItemState[]>) => {
            state.approvalList = action.payload;
        },
        setRefList: (state, action:PayloadAction<IApprRefUsrItemState[]>) => {
            state.refList = action.payload;
        },
        setApprDcdList: (state, action:PayloadAction<IComCdItemState[]>) => {
            state.apprDcdList = action.payload;
        },
        setFileList: (state, action:PayloadAction<[]>) => {
            state.fileList = action.payload;
        },
        setAttachFileItems: (state, action:PayloadAction<IAttachFileItemState[]>) => {
            state.attachFileItems = action.payload;
        },
        addFileList: (state, action:PayloadAction<File>) => {
            let arr : any[] = [...state.fileList];

            const ttt = arr.filter((item:File) => {
                return item === action.payload
            });

            if (ttt.length < 1) {
                arr.push(action.payload);
                return {
                    ...state,
                    fileList: arr as []
                }
            } else {
                return {
                    ...state,
                }
            }
        },
        addAttachFileItems: (state, action:PayloadAction<IAttachFileItemState>) => {
            const arr : any[] = [...state.attachFileItems];

            const ttt = arr.filter((item:any) => {
                return item.orginFileNm === action.payload.orginFileNm
            });

            if (ttt.length < 1) {
                arr.push(action.payload);
                
                return {
                    ...state,
                    attachFileItems: arr as []
                }
            } else {
                return {
                    ...state,
                }
            }
        },
        removeAttachFileItems: (state, action:PayloadAction<any>) => {
            const arr : any[] = [...state.attachFileItems];

            const ttt = arr.filter((item:any) => {
                return item.orginFileNm !== action.payload.orginFileNm
            });
    
            return {
                ...state,
                attachFileItems: ttt as []
            }
        },
        removeFileList: (state, action:PayloadAction<any>) => {
            const arr : any[] = [...state.fileList];

            const ttt = arr.filter((item:any) => {
                return item.name !== action.payload.orginFileNm
            });

            return {
                ...state,
                fileList: ttt as []
            }
        },
    },
});

export default com0109m_Slice.reducer;
export const Com0109mAction  = com0109m_Slice.actions;
export const Com0109mReducer = com0109m_Slice.reducer;